import { css } from 'emotion';

export const teachButton = css`
  margin-left: 4px;
  flex-shrink: 0;

  svg {
    margin-right: 6px;
    height: 14px;
    width: 14px;
  }
`;

export const editSubmission = css`
  display: flex;
  margin-right: 20px;
`;

export const liveClassCard = css`
  &.cardInfoInnerContainer {
    padding: 16px 20px !important;
  }
  .courseName {
    font-size: 74px;
    margin-bottom: 10px;
    text-transform: capitalize;
    font-size: 32px;
    line-height: 1.15;
    letter-spacing: 0.22px;
    color: var(--color-black1);
    font-family: PlayfairDisplay !important;
  }
  .cardGlobalPosition {
    margin-bottom: 0px !important;
  }
  .cardName {
    font-size: 26px !important;
    font-family: PlayfairDisplay !important;
  }
`;
